import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    getPlanos() {
      return new Promise((resolve, reject) => {
        axios.get('/assinatura-agente/plano')
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    registrar(ctx, playload) {
      return new Promise((resolve, reject) => {
        axios.post('/auth/agente/registrar', playload)
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    isExisteUsuario(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.get('/usuario-info/existe-usuario', { params: data })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

  },
}
